import React, { useState, useRef } from "react";
import { Drawer, List, ListItem as MUIListItem, makeStyles, Divider, Box, ListItemIcon, ListItemText, Backdrop, } from "@material-ui/core";
import { typography } from "../../shared/theme";
import { NavLink, useRouteMatch, } from "react-router-dom";
import { ChevronIcon } from "../icons";
import { FTLTooltipPopover } from "../FTLTooltipPopover";
import { FTLButton } from "../FTLButton";
import { useClickOutside } from "ftl-dashboards-core";
function NestedListItemLink({ label, 
// icon,
onClick, to, }) {
    const classes = useStyles({ isMinimized: false });
    const renderLink = React.useMemo(() => React.forwardRef((itemProps, ref) => (React.createElement(NavLink, Object.assign({ to: to, activeClassName: classes.listItemActive, ref: ref }, itemProps)))), [to]);
    return (React.createElement(MUIListItem, { button: true, component: renderLink, onClick: onClick },
        React.createElement(ListItemText, { className: classes.nestedNavItemText, primary: label })));
}
function ListItem({ 
// label,
// icon,
children, onClick, to = "", title, hasSubItems, isMinimized, }) {
    const classes = useStyles({ isMinimized });
    const [isHover, setIsHover] = useState(false);
    const route = to instanceof Function
        ? ""
        : typeof to === "string"
            ? to
            : to.pathname || "";
    const match = useRouteMatch(route);
    const renderLink = React.useMemo(() => React.forwardRef((itemProps, ref) => React.createElement(NavLink, Object.assign({ to: to, ref: ref }, itemProps))), [to]);
    return (React.createElement(MUIListItem, { classes: { root: classes.listItem }, className: match ? classes.listItemActive : "", button: true, 
        // isMinimized={isMinimized}
        component: to && !hasSubItems ? renderLink : "li", onMouseEnter: () => {
            setIsHover(!isHover);
        }, onMouseLeave: () => setIsHover(!isHover), onClick: onClick },
        children,
        hasSubItems && !isMinimized && isHover && (React.createElement(ChevronIcon, { direction: "right" })),
        isHover && isMinimized && (React.createElement(FTLTooltipPopover, { wait: 300, title: title, style: { position: "fixed", left: 72 } }))));
}
export const FTLSideMenu = React.forwardRef(({ items, onMinimize }, ref) => {
    const [isMinimized, setIsMinimized] = useState(false);
    const [nestedListIsOpen, setNestedListIsOpen] = useState(false);
    const [nestedOpenItems, setNestedOpenItems] = useState([]);
    const drawerListRef = useRef(null);
    const nestedListRef = useRef(null);
    const classes = useStyles({ isMinimized });
    const handleOpenMenuItem = (items) => {
        setNestedListIsOpen(true);
        setNestedOpenItems(items);
    };
    const handleCloseMenuItem = () => {
        setNestedListIsOpen(false);
        setNestedOpenItems([]);
    };
    useClickOutside(nestedListRef, () => {
        setNestedListIsOpen(false);
    });
    return items.length > 0 ? (React.createElement("div", { className: classes.sideMenuRoot },
        React.createElement("div", { className: classes.ghostElement }),
        React.createElement("div", { ref: ref, className: classes.sideMenuWrapper },
            React.createElement(Drawer, { variant: "permanent", ref: drawerListRef, classes: {
                    paper: classes.paper,
                } },
                React.createElement(List, { className: classes.list, component: "nav" }, items.map((item, index) => (React.createElement(ListItem, { key: index, to: item.to, title: item.label, isMinimized: isMinimized, hasSubItems: Boolean(item === null || item === void 0 ? void 0 : item.items), onClick: () => {
                        if (item.items) {
                            handleOpenMenuItem(item.items);
                        }
                        else {
                            handleCloseMenuItem();
                        }
                    } },
                    React.createElement(ListItemIcon, { color: "primary", className: classes.listItemIcon }, item.icon),
                    !isMinimized && (React.createElement(ListItemText, { className: classes.listItemText, primary: item.label })))))),
                React.createElement(Box, { marginTop: "auto" },
                    React.createElement(Divider, { style: { backgroundColor: "#EBEDF0" } }),
                    React.createElement(Box, { margin: "4px 12px" },
                        React.createElement(FTLButton, { className: classes.minimizeButton, color: "secondary", variant: "text", startIcon: React.createElement(ChevronIcon, { direction: isMinimized ? "right" : "left" }), onClick: () => {
                                setIsMinimized((val) => {
                                    onMinimize && onMinimize(!val ? 64 : 245);
                                    return !val;
                                });
                            }, fullWidth: true }, !isMinimized && "Свернуть")))),
            nestedListIsOpen && (React.createElement(React.Fragment, null,
                React.createElement(Backdrop, { open: nestedListIsOpen, className: classes.backdrop }),
                React.createElement(List, { disablePadding: true, className: classes.nestedList, innerRef: nestedListRef }, nestedOpenItems.map((item, index) => (React.createElement(NestedListItemLink, { onClick: handleCloseMenuItem, key: index, to: item.to, label: item.label }))))))))) : (React.createElement(React.Fragment, null));
});
const useStyles = makeStyles((theme) => {
    const transition = theme.transitions.create("width", {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.short,
    });
    return {
        root: {
            color: "#132339",
        },
        sideMenuRoot: {
            position: "relative",
            display: "inline-block",
            height: "calc(100vh - 56px)",
        },
        sideMenuWrapper: {
            display: "inline-flex",
            position: "absolute",
            left: 0,
            height: "calc(100vh - 56px)",
        },
        ghostElement: {
            display: "inline-block",
            height: "100%",
            width: ({ isMinimized }) => isMinimized ? 64 : 245,
            transition,
        },
        backdrop: {
            zIndex: 1300,
        },
        paper: {
            backgroundColor: "#F3F4F6",
            overflowX: "hidden",
            // top: "56px",
            zIndex: 1302,
            height: "100%",
            position: "relative",
            borderRight: "1px solid #EBEDF0",
            width: ({ isMinimized }) => isMinimized ? 64 : 245,
            transition,
        },
        list: {
            margin: "0",
            padding: "12px",
            overflowX: "hidden",
            overflowY: "auto",
        },
        listItem: {
            position: "relative",
            borderRadius: "4px",
            minWidth: "40px",
            padding: "0",
            height: "40px",
            "&:hover": {
                backgroundColor: "rgba(3, 11, 22, 0.08)",
            },
        },
        listItemActive: {
            backgroundColor: "rgba(3, 11, 22, 0.08)",
        },
        listItemText: {
            whiteSpace: "nowrap",
            marginTop: "0px",
            marginBottom: "0px",
            paddingLeft: "2px",
            "& > span": Object.assign(Object.assign({}, typography.unsupportedSemanticTags.listItemNavText), { maxWidth: "130px" }),
        },
        listItemIcon: {
            minWidth: "initial",
            color: theme.palette.text.primary,
            padding: "8px",
        },
        nestedList: {
            position: "relative",
            minWidth: "245px",
            boxShadow: "none",
            borderRadius: 0,
            padding: "12px",
            zIndex: 1301,
            backgroundColor: "#fff",
            "& > a": {
                padding: "10px 12px",
                borderRadius: "4px",
                "&:hover": {
                    backgroundColor: "rgba(3, 11, 22, 0.08)",
                },
            },
        },
        nestedNavItemText: {
            margin: 0,
            "& > span": Object.assign({}, typography.unsupportedSemanticTags.listItemNavText),
        },
        item: {
            color: "red",
            "& > a": Object.assign(Object.assign({}, typography.unsupportedSemanticTags.buttonTextSecondary), { textDecoration: "none", color: "#132339" }),
        },
        itemIcon: {
            color: "#132339",
        },
        minimizeButton: {
            justifyContent: "flex-start",
            transition: "inherit",
            padding: ({ isMinimized }) => isMinimized ? "8px 4px 8px 12px !important" : "8px 12px !important",
            "&:hover": {
                backgroundColor: `${theme.palette.button.secondaryHover} !important`,
                "& span": {
                    color: `${theme.palette.text.secondary} !important`,
                },
            },
        },
    };
});
//# sourceMappingURL=index.js.map